module.exports = __webpack_public_path__ + "static/media/matchfitHero.ed8d10e5.jpg";